<div class="container">
   <div class="row">
      <div class="col">
         <div class="service d-flex flex-column align-items-center mb-5 justify-content-center">
            <div class="service-title d-flex justify-content-center mb-5 mr-5 mt-5">
               <button
                  class="service-title__btn btn btn-outline-info text-dark mb-1 ml-5"
                  routerLink="/public/landing-page"
               >
                  <i class="bi bi-arrow-left-short"> </i>{{ 'buttons.back' | translate }}
               </button>
               <div class="service-title__block">
                  <h5 class="service-title__block--tll">{{ pathTranslate + 'title' | translate }}</h5>
               </div>
            </div>
            <div class="service-box d-flex justify-content-center align-items-center mb-5 mt-3">
               <div class="service-box__nbr mr-5">
                  <div class="service-box__nbr--item d-flex justify-content-center align-items-center">
                     <span class="text-white">1</span>
                  </div>
               </div>
               <div class="service-box__item mr-5 d-flex flex-column justify-content-center align-items-center">
                  <p class="service-box__item--text">
                     {{ pathTranslate + 'title1' | translate }}
                  </p>
                  <img
                     class="service-box__item--img"
                     src="./../../../assets/images/integration/Vector.svg"
                     alt="service"
                  />
               </div>

               <div class="service-box__about mr-5 d-flex">
                  <p class="service-box__about--text">
                     {{ pathTranslate + 'data1-1' | translate }}

                     <a
                        href="./../../../assets/doc/Formular%20-cerere%20integrare.docx"
                        download="Formular%20-cerere%20integrare.docx"
                        >({{ pathTranslate + 'download' | translate }})</a
                     >, {{ pathTranslate + 'data1-2' | translate }}
                     <a href="mailto: suport.mdelivery@egov.md">suport.mdelivery@egov.md</a>.
                  </p>
               </div>
            </div>

            <div class="service-box d-flex justify-content-center align-items-center mb-5">
               <div class="service-box__nbr mr-5">
                  <div class="service-box__nbr--item d-flex">
                     <span class="text-white">2</span>
                  </div>
               </div>

               <div class="service-box__item mr-5 d-flex flex-column justify-content-center align-items-center">
                  <p class="service-box__item--text">{{ pathTranslate + 'title2' | translate }}</p>
                  <img
                     class="service-box__item--img"
                     src="./../../../assets/images/integration/Vector-1.svg"
                     alt="international"
                  />
               </div>

               <div class="service-box__about mr-5 d-flex flex-column">
                  <p class="service-box__about--text">
                     {{ pathTranslate + 'data2-1' | translate }}
                  </p>
                  <p class="service-box__about--text">
                     {{ pathTranslate + 'data2-2' | translate }}
                  </p>
                  <a class="service-box__about--link d-flex ml-auto" (click)="seeIntegration()"
                     ><span class="link-text"> {{ pathTranslate + 'read' | translate }}</span>
                     <span [ngClass]="{active: lookIntegration}">
                        <img class="ml-1 mr-1" src="./../../../assets/images/arrowUp.svg" /></span
                  ></a>
               </div>
            </div>

            <div *ngIf="lookIntegration" class="service-read mb-4">
               <p class="service-box__about--text">
                  {{ pathTranslate + 'data2-3' | translate }}
               </p>
               <p class="service-box__about--text">
                  {{ pathTranslate + 'data2-4' | translate }}
               </p>
               <p class="service-box__about--text">
                  {{ pathTranslate + 'data2-5' | translate }}
               </p>
               <p class="service-box__about--text">
                  {{ pathTranslate + 'data2-6' | translate }}
                  <a href="mailto: suport.mdelivery@egov.md">suport.mdelivery@egov.md</a>.
               </p>
            </div>

            <div class="service-box d-flex justify-content-center align-items-center" [ngClass]="{mb: !lookAbout}">
               <div class="service-box__nbr mr-5">
                  <div class="service-box__nbr--item d-flex">
                     <span class="text-white">3</span>
                  </div>
               </div>

               <div class="service-box__item mr-5 d-flex flex-column justify-content-center align-items-center">
                  <p class="service-box__item--text">{{ pathTranslate + 'title3' | translate }}</p>
                  <img
                     class="service-box__item--img"
                     src="./../../../assets/images/integration/Vector-3.svg"
                     alt="toDoor"
                  />
               </div>

               <div class="service-box__about mr-5 d-flex flex-column">
                  <p class="service-box__about--text">
                     {{ pathTranslate + 'data3-1' | translate }}
                  </p>

                  <p class="service-box__about--text">
                     {{ pathTranslate + 'data3-2' | translate }}
                  </p>

                  <a class="service-box__about--link d-flex ml-auto" (click)="seeAbout()"
                     ><span class="link-text"> {{ pathTranslate + 'read' | translate }}</span>
                     <span [ngClass]="{active: lookAbout}"
                        ><img class="ml-1 mr-1" src="./../../../assets/images/arrowUp.svg"
                     /></span>
                  </a>
               </div>
            </div>

            <div *ngIf="lookAbout" class="service-read mb-3 mt-5">
               <p class="service-box__about--text">
                  {{ pathTranslate + 'data3-3' | translate }}
               </p>

               <p class="service-box__about--text">
                  {{ pathTranslate + 'data3-4' | translate }}
               </p>

               <p class="service-box__about--text">
                  {{ pathTranslate + 'data3-5' | translate }}
               </p>

               <div class="service-read__text"></div>
            </div>

            <div class="service-box d-flex justify-content-center align-items-center mb-5 mt-2">
               <div class="service-box__nbr mr-5">
                  <div class="service-box__nbr--item d-flex">
                     <span class="text-white">4</span>
                  </div>
               </div>

               <div class="service-box__item mr-5 d-flex flex-column justify-content-center align-items-center">
                  <p class="service-box__item--text">
                     {{ pathTranslate + 'title4' | translate }}
                  </p>
                  <img
                     class="service-box__item--img"
                     src="./../../../assets/images/integration/Vector-2.svg"
                     alt="howthisWork"
                  />
               </div>

               <div class="service-box__about mr-5">
                  <p class="service-box__about--text">
                     {{ pathTranslate + 'data4-1' | translate }}
                  </p>

                  <p class="service-box__about--text">
                     {{ pathTranslate + 'data4-2' | translate }}
                  </p>
               </div>
            </div>

            <div class="service-box d-flex justify-content-center align-items-center mb-5 mt-2">
               <div class="service-box__nbr mr-5">
                  <div class="service-box__nbr--item d-flex">
                     <span class="text-white">5</span>
                  </div>
               </div>

               <div class="service-box__item mr-5 d-flex flex-column justify-content-center align-items-center">
                  <p class="service-box__item--text">
                     {{ pathTranslate + 'title5' | translate }}
                  </p>
                  <img
                     class="service-box__item--img"
                     src="./../../../assets/images/integration/Vector-4.svg"
                     alt="howthisWork"
                  />
               </div>

               <div class="service-box__about mr-5 d-flex align-items-center">
                  <p class="service-box__about--text mb-0">
                     {{ pathTranslate + 'data5' | translate }}
                  </p>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
